<template>
  <div>
    <v-switch v-if="acl.isAdmin()" style="margin-top: -1rem" v-model="multi" label="Dodawanie użytkowników z pliku">Multi</v-switch>
    <v-form v-if="!multi" v-model="valid" ref="userCreateForm">
      <v-card-text>
        <v-text-field v-model="username" :label="`${$t('user.username')}`" :rules="usernameRules" required></v-text-field>
        <v-text-field v-model="name" :label="`${$t('user.name')}`" :rules="surenameRules" required></v-text-field>
        <v-text-field v-model="surname" :label="`${$t('user.surname')}`" :rules="surenameRules" required></v-text-field>
        <v-text-field v-model="email" :label="`${$t('user.email')}`" :rules="emailRules"></v-text-field>
        <v-select v-model="lang" :items="langs"  :label="`${$t('base.lang')}`"></v-select>
        <v-text-field v-if="acl.isAllowed('canSetPassword')" v-model="password" :append-icon="showPass ? 'visibility_off' : 'visibility'" :type="showPass ? 'text' : 'password'" :label="`${$t('user.password')}`" :rules="passwordRules" @click:append="showPass = !showPass"></v-text-field>
        <v-text-field v-if="acl.isAllowed('canSetPassword')" v-model="confirmPassword" :append-icon="showConfirmPass ? 'visibility_off' : 'visibility'" :type="showConfirmPass ? 'text' : 'password'" :label="`${$t('user.confirm-password')}`" :rules="confirmPasswordRules"
          @click:append="showConfirmPass = !showConfirmPass"></v-text-field>
        <v-select v-model="role" :items="roles" item-text="name" item-value="value" :label="`${$t('user.role')}`" required></v-select>
        <v-select v-if="role !== `admin`" v-model="team" :items="teams" item-text="name" item-value="id" :label="`${$t('user.team')}`" :rules="teamRules"></v-select>
        <v-select v-model="department" :items="departments" item-text="name" item-value="id" :label="`${$t('department.name')}`" required></v-select>
        <v-select v-model="agency" :items="agencies" item-text="name" item-value="id" :label="`${$t('agency.agency')}`" required></v-select>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div :style="getColorIconStyle(colorToHex())" ></div>
            <v-text-field label="Kolor" v-model="hexColor" v-on="on" @change="updateCalendar($event)" class="schema-name-input"></v-text-field>
          </template>

          <v-container style="background-color: #ffffff">
            <color-picker v-bind="color" @input="onInput"></color-picker>
          </v-container>
        </v-menu>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-progress-circular indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-circular>
        <v-btn color="primary" @click="create" :disabled="loading">
          {{ $t('base.create') }}
        </v-btn>
      </v-card-actions>
    </v-form>
    <MultiForm :departments="departments" :agencies="agencies" :roles="allRoles" v-else></MultiForm>
  </div>
</template>

<script>
import Color from '@/mixins/color'
import ColorPicker from '@radial-color-picker/vue-color-picker';
import Role from '@/plugins/Role'
import Acl from "@/plugins/Acl";
import langs from "@/plugins/langs";
import MultiForm from "@/components/user/dialogs/MultiForm";
export default {
  mixins:[Color],
  components: {MultiForm, ColorPicker},
  data() {
    return {
      multi: false,
      roleObj: new Role(),
      loading: false,
      valid: false,
      username: "",
      name: "",
      lang:"pl",
      surname: "",
      email: "",
      password: "",
      department: "",
      departments: [],
      agency : "",
      agencies : [],
      confirmPassword: "",
      showPass: false,
      allRoles: [],
      showConfirmPass: false,
      role: 0,
      acl : new Acl(),
      langs: langs.getSupportedLangs(),
      team: null,
      usernameRules: [
        v => !!v || this.$t('user.create.error.empty-name'),
        v => v.length > 2 || this.$t('user.create.error.min-length-3'),
        v => v.indexOf(' ') < 0 || "",
        v => /^[a-z]\w*$/i.test(v) || this.$t('user.create.error.first-letter')
      ],
      emailRules: [v => /^\S+@\S+\.[a-z]{2,}$/.test(v) || this.$t('user.create.error.incorrect-email')],
      surenameRules: [v => !!v || this.$t('user.create.error.incorrect-surname')],
      passwordRules: [v => !!v || this.$t('user.create.error.empty-pass')],
      confirmPasswordRules: [v => v === this.password || this.$t('user.create.error.pass-not-matching')],
      teamRules: [v => {
        if (["worker", "leader"].indexOf(this.role) != -1 && !v) {
          return this.$t('user.create.error.no-team-for-leader')
        }
        return true
      }]
    }
  },
  computed: {
    roles() {
      return this.allRoles.map(r => ({
        "name": this.roleObj.translateRole(r.name),
        "value": r.name
      }))
    },
    teams() {
      return [{
        id: null,
        name: this.$t('user.create.no-team')
      }].concat(this.$store.state.teams).filter(team => team.assign_hidden == 0)
    }
  },
  methods: {
    create() {
      if (this.$refs.userCreateForm.validate()) {
        this.loading = true
        this.$store.dispatch("createUser", {
          username: this.username,
          name: this.name,
          surname: this.surname,
          email: this.email,
          password: this.password,
          role: this.role,
          team_id: this.team,
          lang : this.lang,
          department_id: this.department,
          agency_id: this.agency,
          calendar_color: this.hexColor
        }).then(() => {
          this.$store.commit("setSnack", {
            message: this.$t("user.create.success-message", {
              username: this.username
            }),
            color: "success"
          })
          this.$refs.userCreateForm.reset()
          this.$emit("exit")
        }).catch((err) => {
          let code = err.response.status
          let errMessage = ""

          if (code == 400) {
            errMessage = this.$t("user.create.incorrect-message")
          } else if (code == 403) {
            errMessage = this.$t("user.create.permision-message")
          } else {
            errMessage = this.$t("user.create.unkown-message")
          }

          this.$store.commit("setSnack", {
            message: this.$t(errMessage),
            color: "failed"
          })
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
  created() {
    this.$http.get('departments').then(data => this.departments = data.data)
    this.$http.get('agencies').then(data => this.agencies = data.data)
    this.$http.get('rbac/roles').then(data => this.allRoles = data.data)
  }
}
</script>

<style scoped>
</style>
